var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.morphedImage)?_c('div',{staticClass:"cropped"},[_c('RawImage',{attrs:{"scale":0.9,"imageData":_vm.morphedImage},on:{"click":function($event){return _vm.$emit('click', $event)}}})],1):_c('div',[_vm._v("Loading...")])}
var staticRenderFns = []

export { render, staticRenderFns }